<template>
  <TransitionGroup
    v-if="!userStore.user?.is_minor"
    tag="div"
    name="loyalty-toast"
    class="fixed bottom-24 left-4 large-desktop:left-10 right-4 mr-auto w-auto large-desktop:w-[350px] flex flex-col gap-4 !z-[10001]"
  >
    <LoyaltyPointsToast
      v-for="notification in loyaltyNotifications.notifications"
      :key="notification.id"
      :notification="notification"
      @dismiss="loyaltyNotifications.onNotificationDismissed"
    />
  </TransitionGroup>
</template>

<script setup lang="ts">
import { useLoyaltyNotifications } from "@/features/channel/services/use-loyalty-notifications";
import LoyaltyPointsToast from "./loyalty-points-toast.vue";
import { useUserStore } from "@/stores/user.store";

const userStore = useUserStore();
const loyaltyNotifications = useLoyaltyNotifications();
</script>

<style scoped>
.loyalty-toast-move {
  transition: all 0.5s ease;
}

.loyalty-toast-enter-active {
  animation: fadeInUp 350ms;
}

.loyalty-toast-leave-active {
  animation: fadeOutDown 500ms;
  position: absolute;
}
</style>
